<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="newClient()" class="btn fixed_btn">New Client</button>
      <div class="card">
        <p class="title">Your Clients</p>
        <table>
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Shipping Address</th>
              <th>Contact Person</th>
              <th>Kiosks</th>
              <th>Edit</th>
              <th>Add Kiosks</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(client, i) in clients">
              <tr :key="i" :class="{ grey: i % 2 }">
                <td data-label="Client Name">
                  {{ `${client.first_name} ${client.last_name}` }}
                </td>
                <td data-label="Shipping Address">
                  <div class="small">
                    <p>{{ client.address.address_1 }}</p>
                    <p>
                      {{ client.address.city }}, {{ client.address.state }}
                      {{ client.address.zip }}
                    </p>
                  </div>
                </td>
                <td data-label="Contact Person">
                  <div v-if="client.contacts[0]" class="small">
                    <p>{{ client.contacts[0].name }}</p>
                    <p>{{ client.contacts[0].email }}</p>
                    <p>{{ client.contacts[0].phone }}</p>
                  </div>
                </td>
                <td data-label="Kiosks">
                  <div class="small btns">
                    <img
                      @click="activate(client)"
                      :class="{
                        clickable: !details,
                        active: details == client.name,
                      }"
                      class="action"
                      src="@/assets/img/arrow.svg"
                    />
                    <p>{{ client.units.length }}</p>
                  </div>
                </td>
                <td data-label="Edit">
                  <img
                    @click="goTo('/client/' + client.id)"
                    class="action clickable"
                    src="@/assets/img/edit.svg"
                  />
                </td>
                <td data-label="Add Kiosks">
                  <img class="action clickable" src="@/assets/img/add.svg" />
                </td>
              </tr>
              <transition name="fade">
                <tr v-if="details == client.name" :class="{ grey: i % 2 }">
                  <td colspan="100%" class="info">
                    <div class="units">
                      <div
                        class="unit"
                        v-for="(unit, i) in client.units"
                        :key="i"
                      >
                        <img class="item-img" src="@/assets/img/kiosk.png" />
                        <p class="name">{{ unit.name }}</p>
                        <div class="unit-amt">{{ unit.quantity }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </transition>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "loginregister",
  components: {
    register: Register,
  },
  data() {
    return {
      details: null,
      user: this.$store.state.reseller,
      clients: [],
    };
  },
  firestore() {
    return {
      clients: db.collection(`reseller_profile/${this.user.id}/clients`),
    };
  },
  mounted() {},
  created() {},
  updated() {},
  methods: {
    activate(item) {
      if (this.details == item.name) {
        this.details = null;
      } else {
        this.details = item.name;
      }
    },
    newClient() {
      let id = db.collection("client").doc().id;
      this.goTo("/client/" + id);
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}
</style>
